<template lang="pug">
	.airtime-log.flex-col.space
		.flex-col
			.flex-col.padding.space
				.flex-row.space.font-big
					a(@click="() => $router.push({ path: `/campaign/List` })") {{$tCaption('Campaings')}}
					span /
					template(v-if="campaignData && campaignData.Name")
						a(@click="() => $router.push({ path: `/campaign/Detail/${campaignIdValue}` })") {{campaignData.Name}}
						span /
					.grey {{$tCaption('Airtime log')}}
				.flex-row.space-large.align-center
					.flex-row.space-medium.align-end
						.flex-col.field(v-if="!campaignId")
							.font-small.upper.grey {{$tCaption('Campaign')}}
							Dropdown(
								:getTotal="(data) => null", :getItems="(data) => data.Results", :getData="$Data.getExternalCampaigns",
								:columns="[{ dataField: 'Name', caption: $tCaption('Campaign') }]",
								displayExpr="Name",
								valueExpr="Oid",
								:placeholder="$tCaption('Choose campaign')",
								:selectedItems="internalCampaignId",
								:showColumnHeaders="false",
								:filtersVisible="false",
								:searchVisible="true",
								:multiple="false",
								@select-data="item => internalCampaignId = item && item.Oid || null")
						.flex-col.field
							.font-small.upper.grey {{$tCaption('Period from')}}
							DxDateBox(:value.sync="dateFrom", :dropDownOptions="dateDropDownOptions", :show-clear-button="true")
						.flex-col.field
							.font-small.upper.grey {{$tCaption('Period to')}}
							DxDateBox(:value.sync="dateTo", :dropDownOptions="dateDropDownOptions", :show-clear-button="true")
					.flex-col.field
						DxButton(:text="$tCaption('Reload', '@actions')", @click="$refs.listView.reload()", icon="refresh")
			ListView.full-width(
				v-if="campaignIdValue",
				ref="listView",
				initialView="table",
				:remoteSorting="false",
				:hideViewsSelection="true",
				:getTotal="(r) => r.TotalNumberOfRecords",
				:getItems="(r) => insertions",
				:getData="loadInsertions",
				:columns="columns",
				:filterRow="false"
			)
				template(v-slot:air-check-template="{ data }")
					.flex-row.space
						template(v-if="data.PlayedStatus === 2")
							.play-button(:id="`pb_${data.ScheduleId}`" @click="toggleActiveScheduleId(data.ScheduleId, data)", :class="{ hover: data.ScheduleId === activeSheduleId }")
								i.fa.fa-play
							Popover(v-if="data.ScheduleId === activeSheduleId", @hide="activeSheduleId = null")
								StationLogPlayer(ref="stationLogPlayer", :stationId="playingStationId", :dateTime="playingDateTime", @close="activeSheduleId = null")
						span.overflow {{data.Material}}
				template(v-slot:play-time="{ data }")
					span {{data.PlayTime && $moment(data.PlayTime).format('llll') }}

</template>

<script>
	import {DxDataGrid, DxPaging, DxColumn, DxSelection, DxSummary, DxTotalItem} from 'devextreme-vue/data-grid';
	import Loader from 'app-core/Loader.vue';
	import DxDateBox from 'devextreme-vue/date-box';
	import VueTypes from 'vue-types';
	import DxButton from 'devextreme-vue/button';
	import StationLogPlayer from './StationLogPlayer.vue';
	import { DxPopover } from 'devextreme-vue/popover';
	import Popover from 'app-core/Popover.vue';
	import ListView from 'app-core/ListView.vue';
	import Dropdown from 'app-core/Dropdown.vue';

	export default {
		translationCategory: 'logs.AirtimeLog',
		name: 'AirtimeLog',
		components: {
			DxDataGrid, DxPaging, DxColumn, DxSelection, DxSummary, DxTotalItem, DxDateBox, Loader, DxButton, StationLogPlayer, DxPopover, Popover, ListView, Dropdown
		},
		props: {
			campaignId: VueTypes.string.def(null)
		},
		data() {
			return {
				isLoading: false,
				insertions: [],
				dateFrom: null,
				dateTo: null,
				dateDropDownOptions: {
					toolbarItems: [
						{
							widget: 'dxButton',
							toolbar: 'bottom',
							location: 'center',
							options: {
								text: () => this.$tCaption('Today'),
								onClick: (e) => {
									if (__DEBUG__)
										console.log('click', e);
									e.component.option('value', new Date());
									e.component.close();
								}
							}
						}
					]
				},
				activeSheduleId: null,
				playedStatuses: [
					this.$tCaption('PreScheduled'),
					this.$tCaption('Scheduled'),
					this.$tCaption('Aired'),
					this.$tCaption('Missed'),
					this.$tCaption('FingerPrinted'),
					this.$tCaption('None'),
				],
				playingStationId: null,
				playingDateTime: null,
				logPlayerHiding: null,
				campaignData: null,
				internalCampaignId: null
			};
		},
		computed: {
			hasImpressions() {
				return (this.insertions || []).some(f => (f.CntImpressions || 0) !== 0);
			},
			columns() {
				return [
					{ dataField: 'AdthosChannelId.Name', caption: () => this.$tCaption('Station') },
					{ dataField: 'SpotTitle', caption: () => this.$tCaption('Title') },
					...(this.$auth.countryCode() === 'US' ? [{ dataField: 'Isci', caption: () => this.$tCaption('ISCI') }] : []),
					{ dataField: 'MaterialId', caption: () => this.$tCaption('Air check'), cellTemplate: 'air-check-template' },
					{ dataField: 'PlayTime', caption: () => this.$tCaption('Play time'), cellTemplate: 'play-time'},
					...(this.hasImpressions ? [{ dataField: 'CntImpressions', caption: () => this.$tCaption('Impressions') }] : []),
					{ dataField: 'SpotLength', caption: () => this.$tCaption('Duration (sec)') },
					{ dataField: 'StatusName', caption: () => this.$tCaption('Status') },
				];
			},
			campaignIdValue() {
				return this.campaignId || this.internalCampaignId;
			}
		},
		watch: {
			campaignIdValue() {
				this.campaignData = null;
				this.loadCampaign();
				this.$refs.listView?.reload();
			}
		},
		created() {
		},
		mounted() {
			if (__DEBUG__)
				window.airtimeLog = this;
			this.loadCampaign();
		},	
		methods: {
			loadCampaign() {
				if (!this.campaignIdValue) return Promise.resolve(null);
				return this.$Data.getExternalApi('campaign/GetCampaign', `campaignId=${this.campaignIdValue}`).then(r => {
					this.campaignData = r;
				});
			},
			toggleActiveScheduleId(v, data) {
				if (v && this.activeSheduleId === v) {
					this.activeSheduleId = null;
				} else {
					this.activeSheduleId = v;
					this.playingItem = data;
					this.logPlayerHiding = () => { if (data.ScheduleId === this.activeSheduleId) this.activeSheduleId = null; };
					this.playingStationId = data.AdthosChannelId?.Oid;
					this.playingDateTime = data.PlayTime;
				}
			},
			loadInsertions(pageIndex, limit, opts) {
				if (!this.campaignIdValue) return Promise.resolve(null);
				this.isLoading = true;
				const dateFromFilter = this.dateFrom ? `&startDate=${this.$moment(this.dateFrom).format('YYYY-MM-DD')}` : '';
				const dateToFilter = this.dateTo ? `&endDate=${this.$moment(this.dateTo).format('YYYY-MM-DD')}` : '';
				return this.$Data.getExternalApi('Reconciliation/GetInsertions', `externalCampaignId=${this.campaignIdValue}${dateFromFilter}${dateToFilter}&page=${pageIndex + 1}` /*`campaignId=20${dateFromFilter}${dateToFilter}&page=${pageIndex + 1}`*/, limit).then(r => {
					this.insertions = r.Results.map(f => ({
						...f,
						StatusName: this.playedStatuses[f.PlayedStatus]
					}));
					return r;
				}).finally(() => this.isLoading = false);
			}
		}
	}
</script>

<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.airtime-log {
		position: relative;

		.play-button {
			min-width: 20px;
			color: #aaa;
			cursor: pointer;

			&:hover, &.hover {
				color: $base-accent;
			}
		}

		.station-log-player {
			min-width: 300px;

			.station-info {
				max-width: 400px;
			}

			.station-name {
				font-size: 14px;
				font-weight: 800;
			}

			.play-date {
				font-size: 12px;
			}

			.station-logo {
				max-height: 60px;
				max-width: 120px;
				height: 60px;
			}
		}
	}
</style>
